import { FlexRow, MaterialIcon, useLoading } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { requestConsumptionReportFile } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import { consumptionDateState } from '../../../storage/reports';
import LastMonthsSelect from '../../shared/LastMonthsSelect';
import { StyledTooltip } from '../../ui/StyledTooltip';

function ConsumptionReportFilters() {
  const { classes } = useStyles();
  const apiParams = useRecoilValue(apiParamsState);
  const [dateKey, setDateKey] = useRecoilState(consumptionDateState);
  const { startLoading, stopLoading, loading } = useLoading();
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const { showPositiveFeedback, showFailFeedback } = useFeedback();

  const createReport = async () => {
    if (!apiParams?.clientId) return;
    startLoading();
    const { error } = await requestConsumptionReportFile(
      apiParams.clientId,
      dateKey,
      isAllWorkspacesSelected ? undefined : apiParams.subClientId
    );
    if (!error) {
      showPositiveFeedback('Tu reporte será procesado, visita la sección de descargas para obtenerlo.');
    } else if (error) {
      showFailFeedback(`${error}`);
    }
    stopLoading();
  };

  return (
    <FlexRow classNames={classes.centeredBetween}>
      <LastMonthsSelect
        onChange={setDateKey}
        dateKey={dateKey}
      />
      <StyledTooltip
        content="Descargar"
        showArrow={false}
        placement="top"
        ignoreBoundary
      >
        <Button
          size="compact"
          shape="circle"
          kind="tertiary"
          isLoading={loading}
          onClick={(e) => {
            e.stopPropagation();
            createReport();
          }}
        >
          <MaterialIcon
            name="download"
            size="compact"
          />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}

export default ConsumptionReportFilters;
